module.exports = __webpack_public_path__ + "team_bw.svg?2e932a4dc13d7c952b389357ca833b18";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns/team_bw.svg
// module id = 21
// module chunks = 0